import { createI18n } from 'vue-i18n'
import nl from './locales/nl.json'
import en from './locales/en.json'
import id from './locales/id.json'

const savedLocale = (typeof localStorage !== 'undefined' && localStorage.getItem('locale')) || 'nl'

export const i18n = createI18n({
    legacy: false,
    locale: savedLocale,
    fallbackLocale: 'nl',
    messages: { nl, en, id }
})
